import React from 'react';
import { Search, Bell, User } from 'lucide-react';
interface TopBarProps {
  userRole: 'Program Manager' | 'Founder';
  toggleRole: () => void;
}
const TopBar: React.FC<TopBarProps> = ({
  userRole,
  toggleRole
}) => {
  return <div className="h-16 px-6 border-b border-gray-200 flex items-center justify-between bg-white" data-id="element-77">
      <div className="relative w-64" data-id="element-78">
        <input type="text" placeholder="Search..." className="w-full pl-10 pr-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-79" />
        <Search className="absolute left-3 top-2.5 text-gray-400" size={18} data-id="element-80" />
      </div>
      <div className="flex items-center space-x-4" data-id="element-81">
        <button onClick={toggleRole} className="px-3 py-1.5 text-sm rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors" data-id="element-82">
          {userRole}
        </button>
        <button className="p-1.5 rounded-full hover:bg-gray-100 transition-colors relative" data-id="element-83">
          <Bell size={20} className="text-gray-600" data-id="element-84" />
          <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full" data-id="element-85"></span>
        </button>
        <div className="flex items-center space-x-2" data-id="element-86">
          <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white" data-id="element-87">
            <User size={16} data-id="element-88" />
          </div>
          <span className="text-sm font-medium text-gray-700" data-id="element-89">
            {userRole === 'Program Manager' ? 'Alex Rivera' : 'Jamie Cole'}
          </span>
        </div>
      </div>
    </div>;
};
export default TopBar;